module.exports = __webpack_public_path__ + "static/media/obrnuti_u_v6.65ddcfdb.png";